import React from "react";
import WorkspaceInternalControls from "../libraries/WorkspaceInternalControls";

interface IntangibleAssetsInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function IntangibleAssetsInternalControls({ onBack, setActiveSection, controlsListSection }: IntangibleAssetsInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Intangible Assets"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

